var isObject = require('../help/is_object');

var epoch = require('../help/epoch');

var secs = require('../help/secs');

var getKey = require('../help/get_key');

var _require = require('../jws/verify'),
    verify = _require.bare;

var _require2 = require('../errors'),
    JWTClaimInvalid = _require2.JWTClaimInvalid,
    JWTExpired = _require2.JWTExpired;

var _require3 = require('./shared_validations'),
    isString = _require3.isString,
    isNotString = _require3.isNotString,
    isNotArrayOfStrings = _require3.isNotArrayOfStrings,
    isTimestamp = _require3.isTimestamp,
    isStringOrArrayOfStrings = _require3.isStringOrArrayOfStrings;

var decode = require('./decode');

var isPayloadString = isString.bind(undefined, JWTClaimInvalid);
var isOptionString = isString.bind(undefined, TypeError);

var normalizeTyp = function normalizeTyp(value) {
  return value.toLowerCase().replace(/^application\//, '');
};

var validateOptions = function validateOptions(_ref) {
  var algorithms = _ref.algorithms,
      audience = _ref.audience,
      clockTolerance = _ref.clockTolerance,
      _ref$complete = _ref.complete,
      complete = _ref$complete === void 0 ? false : _ref$complete,
      crit = _ref.crit,
      _ref$ignoreExp = _ref.ignoreExp,
      ignoreExp = _ref$ignoreExp === void 0 ? false : _ref$ignoreExp,
      _ref$ignoreIat = _ref.ignoreIat,
      ignoreIat = _ref$ignoreIat === void 0 ? false : _ref$ignoreIat,
      _ref$ignoreNbf = _ref.ignoreNbf,
      ignoreNbf = _ref$ignoreNbf === void 0 ? false : _ref$ignoreNbf,
      issuer = _ref.issuer,
      jti = _ref.jti,
      maxTokenAge = _ref.maxTokenAge,
      _ref$now = _ref.now,
      now = _ref$now === void 0 ? new Date() : _ref$now,
      subject = _ref.subject,
      typ = _ref.typ;

  if (typeof complete !== 'boolean') {
    throw new TypeError('options.complete must be a boolean');
  }

  if (typeof ignoreExp !== 'boolean') {
    throw new TypeError('options.ignoreExp must be a boolean');
  }

  if (typeof ignoreNbf !== 'boolean') {
    throw new TypeError('options.ignoreNbf must be a boolean');
  }

  if (typeof ignoreIat !== 'boolean') {
    throw new TypeError('options.ignoreIat must be a boolean');
  }

  isOptionString(maxTokenAge, 'options.maxTokenAge');
  isOptionString(subject, 'options.subject');
  isOptionString(jti, 'options.jti');
  isOptionString(clockTolerance, 'options.clockTolerance');
  isOptionString(typ, 'options.typ');

  if (issuer !== undefined && isNotString(issuer) && isNotArrayOfStrings(issuer)) {
    throw new TypeError('options.issuer must be a string or an array of strings');
  }

  if (audience !== undefined && isNotString(audience) && isNotArrayOfStrings(audience)) {
    throw new TypeError('options.audience must be a string or an array of strings');
  }

  if (algorithms !== undefined && isNotArrayOfStrings(algorithms)) {
    throw new TypeError('options.algorithms must be an array of strings');
  }

  if (!(now instanceof Date) || !now.getTime()) {
    throw new TypeError('options.now must be a valid Date object');
  }

  if (ignoreIat && maxTokenAge !== undefined) {
    throw new TypeError('options.ignoreIat and options.maxTokenAge cannot used together');
  }

  if (crit !== undefined && isNotArrayOfStrings(crit)) {
    throw new TypeError('options.crit must be an array of strings');
  }

  return {
    algorithms: algorithms,
    audience: audience,
    clockTolerance: clockTolerance,
    complete: complete,
    crit: crit,
    ignoreExp: ignoreExp,
    ignoreIat: ignoreIat,
    ignoreNbf: ignoreNbf,
    issuer: issuer,
    jti: jti,
    maxTokenAge: maxTokenAge,
    now: now,
    subject: subject,
    typ: typ
  };
};

var validateTypes = function validateTypes(_ref2, options) {
  var header = _ref2.header,
      payload = _ref2.payload;
  isPayloadString(header.alg, '"alg" header parameter', 'alg', true);
  isTimestamp(payload.iat, 'iat', !!options.maxTokenAge);
  isTimestamp(payload.exp, 'exp');
  isTimestamp(payload.nbf, 'nbf');
  isPayloadString(payload.jti, '"jti" claim', 'jti', !!options.jti);
  isStringOrArrayOfStrings(payload.iss, 'iss', !!options.issuer);
  isPayloadString(payload.sub, '"sub" claim', 'sub', !!options.subject);
  isStringOrArrayOfStrings(payload.aud, 'aud', !!options.audience);
  isPayloadString(header.typ, '"typ" header parameter', 'typ', !!options.typ);
};

var checkAudiencePresence = function checkAudiencePresence(audPayload, audOption) {
  if (typeof audPayload === 'string') {
    return audOption.includes(audPayload);
  } // Each principal intended to process the JWT MUST
  // identify itself with a value in the audience claim


  audPayload = new Set(audPayload);
  return audOption.some(Set.prototype.has.bind(audPayload));
};

module.exports = function (token, key) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isObject(options)) {
    throw new TypeError('options must be an object');
  }

  var _options = options = validateOptions(options),
      algorithms = _options.algorithms,
      audience = _options.audience,
      clockTolerance = _options.clockTolerance,
      complete = _options.complete,
      crit = _options.crit,
      ignoreExp = _options.ignoreExp,
      ignoreIat = _options.ignoreIat,
      ignoreNbf = _options.ignoreNbf,
      issuer = _options.issuer,
      jti = _options.jti,
      maxTokenAge = _options.maxTokenAge,
      now = _options.now,
      subject = _options.subject,
      typ = _options.typ;

  var decoded = decode(token, {
    complete: true
  });
  key = getKey(key, true);

  if (complete) {
    var _verify = verify(true, 'preparsed', {
      decoded: decoded,
      token: token
    }, key, {
      crit: crit,
      algorithms: algorithms,
      complete: true
    });

    key = _verify.key;
    decoded.key = key;
  } else {
    verify(true, 'preparsed', {
      decoded: decoded,
      token: token
    }, key, {
      crit: crit,
      algorithms: algorithms
    });
  }

  var unix = epoch(now);
  validateTypes(decoded, options);

  if (issuer && (typeof decoded.payload.iss !== 'string' || !(typeof issuer === 'string' ? [issuer] : issuer).includes(decoded.payload.iss))) {
    throw new JWTClaimInvalid('unexpected "iss" claim value', 'iss', 'check_failed');
  }

  if (subject && decoded.payload.sub !== subject) {
    throw new JWTClaimInvalid('unexpected "sub" claim value', 'sub', 'check_failed');
  }

  if (jti && decoded.payload.jti !== jti) {
    throw new JWTClaimInvalid('unexpected "jti" claim value', 'jti', 'check_failed');
  }

  if (audience && !checkAudiencePresence(decoded.payload.aud, typeof audience === 'string' ? [audience] : audience)) {
    throw new JWTClaimInvalid('unexpected "aud" claim value', 'aud', 'check_failed');
  }

  if (typ && normalizeTyp(decoded.header.typ) !== normalizeTyp(typ)) {
    throw new JWTClaimInvalid('unexpected "typ" JWT header value', 'typ', 'check_failed');
  }

  var tolerance = clockTolerance ? secs(clockTolerance) : 0;

  if (!ignoreIat && !('exp' in decoded.payload) && 'iat' in decoded.payload && decoded.payload.iat > unix + tolerance) {
    throw new JWTClaimInvalid('"iat" claim timestamp check failed (it should be in the past)', 'iat', 'check_failed');
  }

  if (!ignoreNbf && 'nbf' in decoded.payload && decoded.payload.nbf > unix + tolerance) {
    throw new JWTClaimInvalid('"nbf" claim timestamp check failed', 'nbf', 'check_failed');
  }

  if (!ignoreExp && 'exp' in decoded.payload && decoded.payload.exp <= unix - tolerance) {
    throw new JWTExpired('"exp" claim timestamp check failed', 'exp', 'check_failed');
  }

  if (maxTokenAge) {
    var age = unix - decoded.payload.iat;
    var max = secs(maxTokenAge);

    if (age - tolerance > max) {
      throw new JWTExpired('"iat" claim timestamp check failed (too far in the past)', 'iat', 'check_failed');
    }

    if (age < 0 - tolerance) {
      throw new JWTClaimInvalid('"iat" claim timestamp check failed (it should be in the past)', 'iat', 'check_failed');
    }
  }

  return complete ? decoded : decoded.payload;
};